import request from 'api';

/* =============================== GET ================================ */

/**
 * 클래스 정보 호출 API
 * @version 3
 * @param {object} props
 * @param {number} props.classId 클래스 ID
 */
export const getClass = ({ classId }) => {
  return request.get(`/enfit1/api/v3/class/${classId}`, {
    headers: {
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_DEFAULT_TOKEN}`,
    },
  });
};

/* =============================== POST =============================== */

/* =============================== PUT ================================ */

/* ============================== DELETE ============================== */
